module.exports = "/img/12.fb06eb.webp";